import styled from '@emotion/styled';
import { Text, Tooltip } from '@innovationdepartment/proxima-ui';
import type {
  AudienceTableCellRendererProps,
  LookalikeAudienceTableRowProps
} from 'types/audiences';
import VerticalWrapper from './AudienceRowCell.Wrapper';
import { status as statusUtils } from './utils';

const StatusBadge = styled.div<{ color: string }>`
  align-self: flex-start;
  padding: 0 6px;
  border-radius: 10px;
  background-color: ${({ color }) => color};
`;

const AudienceRowCellLookalikeStatus = ({
  row
}: AudienceTableCellRendererProps<LookalikeAudienceTableRowProps>) => {
  // @ts-expect-error
  const color = statusUtils.color[row?.displayStatus] ?? statusUtils.color.default;

  return (
    <VerticalWrapper>
      <Tooltip title={row?.errorCode || ''} placement="right" arrow>
        <StatusBadge color={color}>
          <Text variant="tag2Medium" color="neutral80">
            {row?.displayStatus}
          </Text>
        </StatusBadge>
      </Tooltip>
    </VerticalWrapper>
  );
};

export default AudienceRowCellLookalikeStatus;
